import { useState } from 'react';
import { Workflow } from 'lucide-react';
import BotSelector from '../../../../../components/BotSelector/BotSelector';

export default function CreateFlowModal({ bots, initialBot, onClose, onCreate }) {
  const [name, setName] = useState('');
  const [bot, setBot] = useState(initialBot);
  const [creating, setCreating] = useState(false);

  async function handleConfirm() {
    if (!name.trim() || !bot || creating) return;
    setCreating(true);
    const ok = await onCreate(bot, name);
    // Em caso de sucesso há navegação; só reabilita se falhar
    if (!ok) setCreating(false);
  }

  return (
    <div className="manage-bots-modal-overlay" onClick={onClose}>
      <div className="manage-bots-modal" style={{ maxWidth: 420 }} onClick={e => e.stopPropagation()}>
        <div className="manage-bots-modal-header">
          <h3><Workflow size={14} style={{ display: 'inline', verticalAlign: 'middle', marginRight: '6px' }} /> Novo Fluxo</h3>
          <button className="manage-bots-close" onClick={onClose}>
            <i className="fas fa-times" />
          </button>
        </div>

        <label className="text-xs font-bold text-white/90 uppercase tracking-wider mt-2 mb-2 block">
          Nome do fluxo
        </label>
        <input
          className="input3 w-full"
          placeholder="Ex.: Boas-vindas"
          value={name}
          maxLength={50}
          onChange={e => setName(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleConfirm()}
          autoFocus
        />

        <label className="text-xs font-bold text-white/90 uppercase tracking-wider mb-2 mt-4 block">
          Bot do fluxo
        </label>
        <BotSelector
          bots={bots}
          selectedBot={bot}
          onSelect={setBot}
          allBotsOption={false}
        />
        <p className="text-xs text-white/30 mt-1">
          O fluxo será executado nas conversas deste bot.
        </p>

        <div className="manage-bots-footer" style={{ marginTop: '1.2rem' }}>
          <div />
          <div className="manage-bots-footer-actions">
            <button className="btn-secondary" onClick={onClose}>Cancelar</button>
            <button className="btn-primary" onClick={handleConfirm} disabled={!name.trim() || !bot || creating}>
              {creating && <i className="fas fa-spinner fa-spin me-1" />}
              Criar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
